











































































import { activateUser } from '@/api/regist';
import { Component, Vue, Prop } from 'vue-property-decorator';
import { ActivateData } from '../../../common/dist/common';

@Component
export default class Activate extends Vue {
  @Prop()
  public error!: string | null;

  @Prop()
  public email!: string;

  private textEmail = '';

  private errorText: string | null = '';
  private password = '';
  private loading = false;
  private valid = false;
  private oneTime = '';
  private success = false;
  private showLogin = false;

  private created() {
    this.errorText = this.error;
    this.textEmail = this.email;
  }

  private async onActivate() {
    this.loading = true;

    const data: ActivateData = {
      email: this.textEmail,
      password: this.password,
      onetime: this.oneTime,
    };
    const ret = await activateUser(data);

    if (ret.success) {
      this.success = true;
      this.showLogin = true;
    } else {
      this.errorText = ret.message;
    }

    this.loading = false;
  }

  private onLogin() {
    this.$router.push({
      name: 'login',
      params: {
        email: this.textEmail,
      },
    });
  }
}
